import type { PlayerManager } from 'chromecast-caf-receiver/cast.framework';

/**
 * Thin wrapper isolating the `@mux/mux-data-chromecast` UMD bundle.
 *
 * The SDK ships as a UMD module with no ES export, so it must be pulled in with
 * `require`. Keeping that `require` behind this dedicated module gives unit
 * tests a clean seam to `vi.mock` — vitest cannot intercept a bare CJS
 * `require` of an external package, but it reliably mocks a local ES import.
 * esbuild resolves the `require` at bundle time, so runtime behavior is
 * unchanged.
 */

/** Callable SDK init that also exposes `utils.now()`. */
export interface InitChromecastMux {
  (playerManager: PlayerManager, options: MuxInitOptions): void;
  utils: { now(): number };
}

export interface MuxInitData {
  env_key: string;
  player_name: string;
  player_init_time: number;
  video_id: string;
  video_title: string;
  video_encoding_variant: string;
  viewer_user_id: string;
  view_client_application_name: string;
  view_client_application_version: string;
}

export interface MuxInitOptions {
  debug: boolean;
  automaticErrorTracking: boolean;
  data: MuxInitData;
}

/** Handle the SDK attaches to the player manager (`playerManager.mux`). */
export interface MuxHandle {
  emit(event: string, data: Record<string, string>): void;
  updateData(data: Record<string, string>): void;
  destroy(): void;
}

// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
export const initChromecastMux = require('@mux/mux-data-chromecast') as InitChromecastMux;
